import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style.js';
const Container = styled.div`
  position: relative;
  background: ${({ color, background }) => color || background || 'white'};
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 7px;
  margin: 10px 20px;
  min-width: ${({ minWidth }) => minWidth || 'auto'};
  padding: ${({ padding }) => padding || '10px 15px'};
  display: ${({ display }) => display || 'flex'};
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  align-self: ${({ alignSelf }) => alignSelf || 'normal'};
  @media(max-width: ${device.mobile}) {
    margin: 5px;
    min-width: 100%;
    padding: ${({ mobilePadding }) => mobilePadding  || '10px 15px'};
  }
`;

export default ({ ...rest }) => <Container {...rest} />;